import React, { useState } from 'react'
import { AppBar } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'

import './bookameetingTopbar.css'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(() => ({
  root: {
    boxShadow: 'none',
    backgroundColor: 'white'
  }
}))

const BookameetingTopbar = props => {
  const { className, ...rest } = props
  const classes = useStyles()

  const {
    nch,
    nchLink,
    hotelsAndDestinations,
    hotelsAndDestinationsLink,
    conferencesAndMeetings,
    conferencesAndMeetingsLink,
    menu,
    close,
    lookingFor,
    specialOffers,
    specialOffersLink,
    ncc,
    nccLink,
    inspiration,
    inspirationLink,
    corporateAgreement,
    corporateAgreementLink,
    sportsTeams,
    sportsTeamsLink,
    ourDestinations,
    ourDestinationsLink,
    packages,
    packagesLink,
    ourHotels,
    comfortHotel,
    comfortHotelLink,
    qualityHotel,
    qualityHotelLink,
    clarionHotelCollection,
    clarionHotelLink,
    visitOneOf,
    visitOneOfLink,
    becomeAMember
  } = useSelector(state => state.language.text)

  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed">
      <div id="header-wrapper-nch">
        <header
          id="global-nav-wrapper"
          style={{ backgroundColor: 'rgb(0, 51, 67)!important' }}
          className="clearfix js-header">
          <div className="page__contener clearix">
            <div className="push-left">
              <a
                href={nchLink}
                className="js-home-page-navigation-with-state-clear header__logo">
                {nch}
              </a>
            </div>
            <div className="push-left">
              <ul className="header__conf-nav">
                <li className="header__conf-nav--element">
                  <a
                    href={hotelsAndDestinationsLink}
                    title={hotelsAndDestinations}
                    className="header__link--open  js-home-page-navigation-with-state-clear">
                    <span className="footer-header-link__inside">
                      {hotelsAndDestinations}
                    </span>
                  </a>
                </li>
                <li className="header__conf-nav--element">
                  <a
                    href={conferencesAndMeetingsLink}
                    title={conferencesAndMeetings}
                    className="header__link--open   ">
                    <span className="footer-header-link__inside">
                      {conferencesAndMeetings}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="push-right">
              <ul style={{ marginRight: 8 }}>
                <li
                  className={
                    !isDropdownOpen
                      ? 'header__nav--element header-links nch-dropdown-menu'
                      : 'header__nav--element header-links nch-dropdown-menu dropdown-menu-closed'
                  }
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                  <div
                    // href
                    role="menuitem"
                    className="header__link--open js-link-open">
                    <span
                      id=" menu-icon-hamburger"
                      style={{ fontFamily: '"nch-icons"!important' }}
                      className={
                        !isDropdownOpen
                          ? 'nch-icon-menu menu-icon-hamburger'
                          : 'nch-icon-menu menu-icon-hamburger dropdown-item-hide'
                      }
                    />
                    <span
                      id=" menu-icon-x"
                      style={{
                        fontFamily: '"nch-icons"!important',
                        position: 'relative',
                        color: '#bdf0f6',
                        top: '-2px'
                      }}
                      className={
                        !isDropdownOpen
                          ? 'nch-icon-menu menu-icon-x dropdown-item-hide'
                          : 'nch-icon-menu menu-icon-x'
                      }
                    />
                    <span
                      style={{ fontWeight: 500 }}
                      id="menu-display"
                      className={
                        !isDropdownOpen
                          ? 'header-links__btn header-links__btn--menu hide-on-fablet menu-display'
                          : 'header-links__btn header-links__btn--menu hide-on-fablet menu-display dropdown-item-hide'
                      }>
                      {menu}
                    </span>
                    <span
                      style={{ fontWeight: 500, color: '#bdf0f6' }}
                      id="menu-close"
                      className={
                        !isDropdownOpen
                          ? 'header-links__btn header-links__btn--close menu-close dropdown-item-hide'
                          : 'header-links__btn header-links__btn--close menu-close'
                      }>
                      {close}
                    </span>
                  </div>
                </li>
              </ul>
              <div></div>
            </div>
            <div
              className={
                !isDropdownOpen
                  ? 'header__dropdown dropdown-item-hide'
                  : 'header__dropdown'
              }
              style={{ display: null }}>
              <div className="page__wrapper">
                <div className="grid1">
                  <div className="grid__item palm--one-whole lap--three-eighths desk--one-quarter">
                    <span className="h3 header__title">{lookingFor}</span>
                    <ul className="no-bullet-list hide-on-desk">
                      <li>
                        <a
                          href={hotelsAndDestinationsLink}
                          title={hotelsAndDestinations}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {hotelsAndDestinations}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={conferencesAndMeetingsLink}
                          title={conferencesAndMeetings}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {conferencesAndMeetings}
                          </span>
                        </a>
                      </li>
                    </ul>
                    <ul className="no-bullet-list">
                      <li>
                        <a
                          href={specialOffersLink}
                          title={specialOffers}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {specialOffers}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={nccLink}
                          title={ncc}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {ncc}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={inspirationLink}
                          title={inspiration}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {inspiration}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={corporateAgreementLink}
                          title={corporateAgreement}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {corporateAgreement}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={sportsTeamsLink}
                          title={sportsTeams}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {sportsTeams}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={ourDestinationsLink}
                          title={ourDestinations}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {ourDestinations}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href={packagesLink}
                          title={packages}
                          className="header__link   ">
                          <span className="footer-header-link__inside">
                            {packages}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="grid__item palm--one-whole lap--five-eighths desk--three-quarters hide-on-fablet">
                    <span className="h3 header__title">{ourHotels}</span>
                    <ul className="our-hotels no-bullet-list--line">
                      <li>
                        <a
                          style={{ color: '#bdf0f6!important' }}
                          href={comfortHotelLink}
                          className="header__link">
                          <img
                            src="https://www.nordicchoicehotels.com/globalassets/global/brandcolorthemeimages/normal/comfort.png"
                            alt={comfortHotel}
                          />
                          {comfortHotel}
                        </a>
                      </li>
                      <li>
                        <a
                          style={{ color: '#bdf0f6!important' }}
                          href={qualityHotelLink}
                          className="header__link">
                          <img
                            src="https://www.nordicchoicehotels.com/globalassets/global/brandcolorthemeimages/normal/quality-hotel.png"
                            alt={qualityHotel}
                          />
                          {qualityHotel}
                        </a>
                      </li>
                      <li>
                        <a
                          style={{ color: '#bdf0f6!important' }}
                          href={clarionHotelLink}
                          className="header__link">
                          <img
                            src="https://www.nordicchoicehotels.com/globalassets/global/brandcolorthemeimages/normal/clarion.png"
                            alt={clarionHotelCollection}
                          />
                          {clarionHotelCollection}
                        </a>
                      </li>
                      <li className="our-hotels__independent header__link">
                        <a
                          style={{ color: '#bdf0f6!important' }}
                          href={visitOneOfLink}
                          className="header__link">
                          {visitOneOf}
                          <span
                            style={{ fontFamily: '"nch-icons"!important' }}
                            className="nch-icon-arrow-right"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </AppBar>
  )
}

export default BookameetingTopbar
